let selectors = {
  input: '.js-qty__num',
  plus: '.js-qty__adjust--plus',
  minus: '.js-qty__adjust--minus'
}

export default class QtySelector {
  constructor(el, options) {
    this.wrapper = el
    this.plus = el.querySelector(selectors.plus)
    this.minus = el.querySelector(selectors.minus)
    this.input = el.querySelector(selectors.input)
    this.minValue = this.input.getAttribute('min') || 1

    let defaults = {
      namespace: null,
      isCart: false,
      key: this.input.dataset.id
    }

    this.options = Object.assign({}, defaults, options)

    this.init()
  }

  init() {
    this.plus.addEventListener(
      'click',
      function (e) {
        this._loading();
        let _key = jQuery(this);
        let qty = this._getQty()
        this._change(qty + 1, jQuery(this)[0].options.key)
      }.bind(this)
    )

    this.minus.addEventListener(
      'click',
      function () {
        this._loading();
        let qty = this._getQty()
        this._change(qty - 1, jQuery(this)[0].options.key)
      }.bind(this)
    )

    this.input.addEventListener(
      'change',
      function (evt) {
        this._loading();
        this._change(this._getQty(), jQuery(this)[0].options.key)
      }.bind(this)
    )
  }

  _getQty() {
    let qty = this.input.value
    if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1
    }
    return parseInt(qty)
  }

  _change(qty, _key) {
    if (qty <= this.minValue) {
      qty = this.minValue
    }

    this.input.value = qty

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "line": Number(this.input.parentElement.parentElement.getAttribute('line')),
        "quantity": qty,
        "id": this.input.parentElement.parentElement.getAttribute('vid')
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(data);
      if(data != '') {
        let subtotal = (data.items_subtotal_price / 100).toFixed(2),
        decimals = subtotal.split('.')[1];
        document.querySelector('div[data-subtotal] span.formatted-price-text').innerHTML = '$' + subtotal.split('.')[0] + '<sup>' + decimals + '</sup>';
        document.querySelector('span.visually-hidden').innerHTML = '$' + subtotal;

        document.querySelectorAll('[data-products]').forEach((elm) => {
          elm.classList.remove('loading');
        });
      }
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }

  _loading() {
    if(document.querySelectorAll('[data-products]').length > 0) {
      document.querySelectorAll('[data-products]').forEach((elm) => {
        elm.classList.add('loading');
      });
    }
  }
}
